import StagingConfig from './staging-config';
import ProdConfig from './prod-config';

const config = (process.env.REACT_APP_DEPLOY_ENV === 'prod') ? ProdConfig : StagingConfig;

export default config;